module.exports = __webpack_public_path__ + "static/media/covid-medicine.fce88744.png";